(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CompendiumDeleteController',CompendiumDeleteController);

    CompendiumDeleteController.$inject = ['$uibModalInstance', 'entity', 'Compendium'];

    function CompendiumDeleteController($uibModalInstance, entity, Compendium) {
        var vm = this;

        vm.compendium = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Compendium.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
